import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { APP_INITIALIZER, LOCALE_ID, NgModule } from '@angular/core';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';

import { getAngularLocale } from '~/core/helpers/locale/locale.helper';

import { environment } from '~environments/environment';
import { LocaleInterceptor } from './interceptors/locale.interceptor';
import { LocaleService } from './services/locale.service';

export const configuredLang = Object.keys(
  environment?.applications?.phrase?.locales
);

/**
 * Translation
 * Do not import in other modules than app.module.ts
 */
@NgModule({
  exports: [],
  imports: [HttpClientModule],
  providers: [
    {
      provide: APP_INITIALIZER,
      useFactory: (
        localeService: LocaleService,
        translateService: TranslateService
      ) => {
        return () => {
          // watch lang change in order to import dependencies
          translateService.onLangChange.subscribe((event: LangChangeEvent) => {
            if (translateService.currentLang !== event.lang) {
              return localeService.importLang(event.lang);
            }
          });

          // make app wait default locale load
          return localeService.importLang(translateService.currentLang);
        };
      },
      multi: true,
      deps: [LocaleService, TranslateService],
    },
    // no factory as locale id cannot be set at runtime ...
    {
      provide: LOCALE_ID,
      useValue: getAngularLocale(environment.fallbackLocale),
    },
    {
      provide: HTTP_INTERCEPTORS,
      useFactory: (translateService: TranslateService) => {
        return new LocaleInterceptor(
          [
            '/',
            environment.applications.front.url,
            environment.applications.activities.url,
          ],
          translateService
        );
      },
      multi: true,
      deps: [TranslateService],
    },
  ],
})
export class I18nModule {}
